import type {EagGridState} from '../store/createEagGridStore';

/** Shared readiness contract for clipboard targets; unrelated pending columns do not block a copy. */
export function isClipboardCopyAllowed(
  state: EagGridState,
  columnKeys: readonly string[]
): boolean {
  const visibleKeys = new Set(
    state.columnStates.filter((column) => column.hidden !== true).map((column) => column.key)
  );
  const pendingKeys = new Set(state.pendingColumnKeys);

  return (
    state.definition?.behavior.clipboardExportAllowed === true &&
    state.fetchState !== 'loading' &&
    state.fetchState !== 'error' &&
    state.rows.length > 0 &&
    columnKeys.length > 0 &&
    columnKeys.every((key) => visibleKeys.has(key) && !pendingKeys.has(key))
  );
}
